export const CLEARPAY_MIN_SPEND = 30;
export const CLEARPAY_MAX_SPEND = 1000;
export const KLARNA_MIN_SPEND = 30;
export const KLARNA_MAX_SPEND = 2000;
